(function () {
  'use strict';
  function ensureLightbox() {
    if (document.getElementById('lb-lightbox')) return document.getElementById('lb-lightbox');
    var box = document.createElement('div');
    box.id = 'lb-lightbox';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-hidden', 'true');
    box.innerHTML = '<button id="lb-lightbox-close" aria-label="Close">&times;</button><img alt="" />';
    document.body.appendChild(box);
    var img = box.querySelector('img');
    function close() {
      box.classList.remove('lb-show');
      box.setAttribute('aria-hidden', 'true');
      setTimeout(function () { if (!box.classList.contains('lb-show')) { box.style.display = 'none'; } }, 420);
    }
    box.addEventListener('click', function (e) {
      if (e.target === box || e.target.id === 'lb-lightbox-close') close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && box.classList.contains('lb-show')) close();
    });
    box._open = function (src) {
      img.src = src;
      box.style.display = 'flex';
      // force reflow then show for transition
      void box.offsetWidth;
      box.classList.add('lb-show');
      box.setAttribute('aria-hidden', 'false');
    };
    return box;
  }
  function init() {
    // Match both bare IDs and the template-prefixed IDs Shopify generates
    // when sections are defined inside templates/index.json (e.g.
    // "shopify-section-template--17981713744004__section_featured_style_gallery").
    var nodes = document.querySelectorAll(
      '[id*="section_featured_style_gallery_Aene4D"], ' +
      '[id*="section_featured_style_gallery"]:not([id*="_Aene4D"])'
    );
    Array.prototype.forEach.call(nodes, function (section) {
      if (!section.id || section.id.indexOf('shopify-section') !== 0) return;
      var slider = section.querySelector('.aso-slider');
      if (!slider || slider.dataset.lbMqInit === '1') return;
      slider.dataset.lbMqInit = '1';
      // Duplicate children once so the -50% animation produces a seamless loop.
      var originals = Array.prototype.slice.call(slider.children);
      originals.forEach(function (child) {
        var clone = child.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.classList.add('lb-mq-clone');
        slider.appendChild(clone);
      });
      // Wire click-to-lightbox on every gallery card (originals + clones).
      var lightbox = ensureLightbox();
      slider.addEventListener('click', function (e) {
        var card = e.target.closest('.gallery-card-aso, .grid__item');
        if (!card) return;
        var img = card.querySelector('img');
        if (!img || !img.src) return;
        e.preventDefault();
        e.stopPropagation();
        // Use a higher-resolution version for the lightbox by stripping width hints.
        var src = img.currentSrc || img.src;
        // Replace any width=NNN query in Shopify CDN URL with width=2000 for crisp display.
        src = src.replace(/(\?|&)width=\d+/, '$1width=2000');
        lightbox._open(src);
      });
      // Pause when fully off-screen for performance. Use a generous rootMargin
      // so the marquee never pauses while any part is near the viewport — this
      // prevents the animation from appearing "stuck" on mobile when partially scrolled.
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) section.classList.remove('lb-mq-paused');
            else section.classList.add('lb-mq-paused');
          });
        }, { threshold: 0, rootMargin: '200px 0px 200px 0px' });
        io.observe(section);
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
